<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="chartSaveAsDialogTitle"
    class="text-s2 mb-9 mt-5 flex-grow select-none text-left text-2xl font-semibold"
    >Save As</div
  >

  <div
    data-cy="chartSaveAsDialogNewChartCheckbox"
    class="flex h-9 flex-row items-center"
  >
    <div
      class="flex cursor-pointer flex-row items-center"
      (click)="newChartOnClick()"
    >
      <div
        class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
        [ngClass]="{
          'bg-m600': chartSaveAs === chartSaveAsEnum.NEW_CHART
        }"
      >
        <m-check-icon
          *ngIf="chartSaveAs === chartSaveAsEnum.NEW_CHART"
        ></m-check-icon>
      </div>

      <div class="ml-5 text-base">New Chart</div>
    </div>
  </div>

  <div
    data-cy="chartSaveAsDialogNewTileOfDashboardCheckbox"
    class="mt-5 flex h-9 flex-row items-center"
  >
    <div
      class="flex cursor-pointer flex-row items-center"
      (click)="tileOfDashboardOnClick()"
    >
      <button
        class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
        [ngClass]="{
          'bg-m600': chartSaveAs === chartSaveAsEnum.TILE_OF_DASHBOARD
        }"
      >
        <m-check-icon
          *ngIf="chartSaveAs === chartSaveAsEnum.TILE_OF_DASHBOARD"
        ></m-check-icon>
      </button>

      <div class="ml-5 mr-5 flex flex-shrink-0 text-base"
        >Tile of Dashboard</div
      >
    </div>

    <div class="flex flex-row items-center">
      <div
        class="relative mx-5 flex h-2 w-9 flex-shrink-0"
        *ngIf="
          !dashboardUnits && chartSaveAs === chartSaveAsEnum.TILE_OF_DASHBOARD
        "
      >
        <ngx-spinner
          [ngClass]="{
            invisible: chartSaveAs !== chartSaveAsEnum.TILE_OF_DASHBOARD
          }"
          class="invisible"
          [name]="spinnerName"
          color="#0084d1"
          bdColor="#00000000"
          size="default"
          type="ball-clip-rotate"
          [fullScreen]="false"
          [disableAnimation]="true"
          [zIndex]="10"
        >
        </ngx-spinner>
      </div>

      <ng-select
        #chartSaveAsDialogDashboardSelect
        [fixNgSelectBottom]="chartSaveAsDialogDashboardSelect"
        data-cy="chartSaveAsDialogDashboardSelect"
        *ngIf="
          !!dashboardUnits && chartSaveAs === chartSaveAsEnum.TILE_OF_DASHBOARD
        "
        class="w-[500px] flex-shrink-0 text-base"
        [items]="dashboardUnits"
        [searchable]="false"
        [clearable]="false"
        [(ngModel)]="selectedDashboardId"
        (click)="$event.stopPropagation()"
        (change)="selectedDashboardChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation();
          chartSaveAsDialogDashboardSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation();
          chartSaveAsDialogDashboardSelect.blur()
        "
        appendTo="body"
        bindLabel="title"
        bindValue="dashboardId"
      >
        <ng-template ng-label-tmp ng-option-tmp let-item="item">
          <div
            class="ml-1 flex flex-row"
            [tpIsEnabled]="item.canEditOrDeleteDashboard === false"
            tp="Dashboard can be modified by author and project members with ProjectAdmin or FilesEditor role. Try to save dashboard as new to become an author."
          >
            <div class="flex truncate">
              <div class="truncate">
                {{ item.title || item.dashboardId }}
              </div>
            </div>
            <div class="flex flex-grow"></div>
            <div class="ml-5 mr-5 flex flex-shrink-0 font-semibold">{{
              item.author
            }}</div>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="mt-8 min-h-[135px]">
    <ng-container *ngIf="chartSaveAs === chartSaveAsEnum.NEW_CHART">
      <div class="flex flex-row items-start">
        <div class="flex flex-col">
          <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
            >Space</div
          >
        </div>

        <div
          class="ml-5 flex flex-col items-start"
          tp="Admin or Editor role required"
          [tpIsEnabled]="canSpecifyChartSpace === false"
        >
          <ng-select
            #chartSaveAsDialogSpaceSelect
            [fixNgSelectBottom]="chartSaveAsDialogSpaceSelect"
            data-cy="chartSaveAsDialogSpaceSelect"
            class="select-h-10 w-96 flex-shrink-0"
            [ngClass]="{
              'pointer-events-none': canSpecifyChartSpace === false
            }"
            [class.report-space-select-disabled]="
              canSpecifyChartSpace === false
            "
            [items]="spacesPlusEmpty"
            [multiple]="false"
            [searchable]="true"
            [clearable]="false"
            [disabled]="canSpecifyChartSpace === false"
            [(ngModel)]="selectedSpace"
            (change)="spaceChange()"
            (keyup.esc)="
              $event.stopImmediatePropagation();
              chartSaveAsDialogSpaceSelect.blur()
            "
            (keyup.enter)="
              $event.stopImmediatePropagation();
              chartSaveAsDialogSpaceSelect.blur()
            "
            appendTo="body"
            bindLabel="label"
            bindValue="space"
          >
            <ng-template ng-label-tmp let-item="item">
              <div class="ml-1 truncate text-base">{{
                item.space === emptySpaceName ? '' : item.label
              }}</div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <div class="ml-1 truncate text-base">{{ item.label }}</div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div class="mt-5 flex flex-row items-start">
        <div class="flex flex-col">
          <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
            >Access Roles</div
          >
        </div>

        <div class="ml-5 flex flex-col items-start">
          <div [tp]="templateAddAccessRole" [tpIsEnabled]="roles.length === 0">
            <ng-template #templateAddAccessRole>
              <div>Project has no roles</div>
            </ng-template>

            <ng-select
              #chartSaveAsDialogRoleSelect
              [fixNgSelectBottom]="chartSaveAsDialogRoleSelect"
              data-cy="chartSaveAsDialogRoleSelect"
              class="select-h-10 w-96 flex-shrink-0"
              [items]="roles"
              [multiple]="true"
              [searchable]="true"
              [clearable]="true"
              [(ngModel)]="selectedAccessRoles"
              (change)="accessRolesChange()"
              (keyup.esc)="
                $event.stopImmediatePropagation();
                chartSaveAsDialogRoleSelect.blur()
              "
              (keyup.enter)="
                $event.stopImmediatePropagation();
                chartSaveAsDialogRoleSelect.blur()
              "
              appendTo="body"
              bindLabel="roleId"
              bindValue="roleId"
            >
              <ng-template ng-label-tmp let-item="item">
                <div
                  class="truncate rounded bg-green-200 px-2 text-base text-green-700"
                  >{{ item.roleId }}</div
                >
              </ng-template>

              <ng-template ng-option-tmp let-item="item">
                <div class="ml-1 truncate text-base">{{ item.roleId }}</div>
              </ng-template>
            </ng-select>

            <div class="ml-[14px] mt-2 flex w-96 flex-wrap gap-2 text-base">
              <span
                *ngFor="let accessRole of combinedAccessRoles"
                class="truncate rounded px-2"
                [ngClass]="{
                  'bg-green-200 text-green-700': accessRole.isDirect,
                  'bg-slate-200 text-slate-700': !accessRole.isDirect
                }"
              >
                {{ accessRole.role }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="chartSaveAs === chartSaveAsEnum.TILE_OF_DASHBOARD">
      <div class="ml-12 flex h-9 flex-col">
        <div
          data-cy="chartSaveAsDialogNewChartCheckbox"
          class="flex h-9 w-fit cursor-pointer flex-row items-center"
          *ngIf="!!selectedDashboardId"
          (click)="newTileOnClick()"
        >
          <div
            class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
            [ngClass]="{
              'bg-m600': tileSaveAs === tileSaveAsEnum.NEW_TILE
            }"
          >
            <m-check-icon
              *ngIf="tileSaveAs === tileSaveAsEnum.NEW_TILE"
            ></m-check-icon>
          </div>

          <div class="ml-5 text-base">New Tile</div>
        </div>
      </div>

      <div class="ml-12 mt-5 flex h-9 flex-col">
        <div
          data-cy="chartSaveAsDialogNewTileOfDashboardCheckbox"
          class="flex h-9 flex-row items-center"
          *ngIf="!!selectedDashboardId"
        >
          <div
            class="flex cursor-pointer flex-row items-center"
            (click)="replaceExistingTileOnClick()"
          >
            <button
              class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
              [ngClass]="{
                'bg-m600': tileSaveAs === tileSaveAsEnum.REPLACE_EXISTING_TILE
              }"
            >
              <m-check-icon
                *ngIf="tileSaveAs === tileSaveAsEnum.REPLACE_EXISTING_TILE"
              ></m-check-icon>
            </button>

            <div class="ml-5 mr-5 flex flex-shrink-0 text-base"
              >Replace Existing Tile</div
            >
          </div>

          <div class="flex flex-row items-center">
            <div
              class="relative flex h-9 w-9 flex-shrink-0"
              *ngIf="
                !selectedDashboardLoaded &&
                tileSaveAs === tileSaveAsEnum.REPLACE_EXISTING_TILE
              "
            >
              <ngx-spinner
                [name]="selectedDashboardSpinnerName"
                color="#0084d1"
                bdColor="#00000000"
                size="default"
                type="ball-clip-rotate"
                [fullScreen]="false"
                [disableAnimation]="true"
                [zIndex]="10"
              >
              </ngx-spinner>
            </div>

            <ng-select
              #chartSaveAsDialogTileSelect
              [fixNgSelectBottom]="chartSaveAsDialogTileSelect"
              data-cy="chartSaveAsDialogTileSelect"
              *ngIf="
                !!selectedDashboardLoaded &&
                tileSaveAs === tileSaveAsEnum.REPLACE_EXISTING_TILE
              "
              class="w-[500px] flex-shrink-0 text-base"
              [items]="selectedDashboard?.tiles || []"
              [searchable]="false"
              [clearable]="false"
              (click)="$event.stopPropagation()"
              (change)="selectedTileChange()"
              [(ngModel)]="selectedTileTitle"
              (keyup.esc)="
                $event.stopImmediatePropagation();
                chartSaveAsDialogTileSelect.blur()
              "
              (keyup.enter)="
                $event.stopImmediatePropagation();
                chartSaveAsDialogTileSelect.blur()
              "
              appendTo="body"
              bindLabel="title"
              bindValue="title"
            >
              <ng-template ng-label-tmp let-item="item">
                <div class="ml-1 truncate">{{ item.title }}</div>
              </ng-template>

              <ng-template ng-option-tmp let-item="item">
                <div class="ml-1 truncate">{{ item.title }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="text-s400 mt-9 h-7 text-base">
    <div *ngIf="chartSaveAs === chartSaveAsEnum.NEW_CHART">{{
      newChartPath
    }}</div>

    <div
      *ngIf="
        chartSaveAs === chartSaveAsEnum.TILE_OF_DASHBOARD &&
        !!selectedDashboardId
      "
      >{{ selectedDashboardPath }}</div
    >

    <!-- <div
      *ngIf="
        chartSaveAs === chartSaveAsEnum.NEW_TILE_OF_EXISTING_DASHBOARD &&
        !selectedDashboardId
      "
    ></div> -->
  </div>

  <div class="mt-9 flex flex-row items-start">
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Title</div
      >
    </div>

    <div [formGroup]="titleForm" class="ml-5 flex flex-col items-start">
      <textarea
        spellcheck="false"
        data-cy="chartSaveAsDialogTitleInput"
        class="form-input border-s3 focus:border-m600 h-[120px] w-[600px] resize-none rounded"
        [ngClass]="{
          'border-r600':
            titleForm.controls['title'].invalid &&
            titleForm.controls['title'].touched
        }"
        formControlName="title"
      ></textarea>
      <m-validation [control]="titleForm.controls['title']"></m-validation>
    </div>
  </div>

  <!-- <div class="flex h-9 flex-row items-start">
    <div
      class="flex flex-col"
      *ngIf="chartSaveAs === chartSaveAsEnum.NEW_CHART"
    >
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Access Roles</div
      >
    </div>

    <div
      [formGroup]="rolesForm"
      class="ml-5 flex flex-col items-start"
      *ngIf="chartSaveAs === chartSaveAsEnum.NEW_CHART"
    >
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="chartSaveAsDialogRolesInput"
        class="form-input border-s3 focus:border-m600 h-9 w-96 rounded"
        [ngClass]="{
          'border-r600':
            rolesForm.controls['roles'].invalid &&
            rolesForm.controls['roles'].touched
        }"
        formControlName="roles"
      />
      <m-validation [control]="rolesForm.controls['roles']"></m-validation>
    </div>
  </div> -->

  <div class="mt-9">
    <button
      data-cy="chartSaveAsDialogSaveButton"
      class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
      type="button"
      [ngClass]="{
        'bg-m600': isSaveDisabled() === false,
        'bg-s400 cursor-default': isSaveDisabled() === true
      }"
      (click)="save()"
      [disabled]="isSaveDisabled()"
      >Save</button
    >

    <button
      data-cy="chartSaveAsDialogCancelButton"
      class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="cancel()"
      >Cancel</button
    >
  </div>
</div>
